import React, {useState} from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import Logo from "../images/stena-bulk-horizontal-light.svg"
import MenuSeparator from "../images/menu-angle.svg"
import styled from "@emotion/styled"
import { useStaticQuery, graphql} from "gatsby"


const HeaderBar = styled.header `
  width: 100%;
  background: rgba(0,53,108,1);
  padding-left: 5%;
  display:flex;
  align-items: center;
  justify-content: space-between;
  z-index: 300;
  @media( min-width:768px) {
    padding-left: 5%;
  }
  @media only screen and (-webkit-min-device-pixel-ratio: 1.25) {
    zoom: 80%!important;
  }
  @media only screen and (-webkit-min-device-pixel-ratio: 1.35) and (-webkit-max-device-pixel-ratio: 1.5) {
    zoom: 70%!important;
  }
`

const HeaderLogo = styled.div `
  flex:1;
  display:flex;
  align-items: center;
  min-height: 56px;
  @media( min-width:767px) {
    min-height: 70px;
  }

  img {
    width: 250px;
    margin-top: 4px;
    @media( max-width:767px) {
      max-width: 210px;
    }
  }
`


const ContactMenuStyles = styled.button `
  background: rgba(277,33,24,1);
  display:flex;
  align-items: center;
  justify-content: flex-end;
  width: 25%;
  min-height: 56px;
  min-width: 110px;
  color: white;
  cursor: pointer;
  border:none;
  outline: none;
  position: relative;
  transition: background ease-in-out 200ms;
  &:hover {
    background: rgba(192,32,25,1);
  }
  &:before {
    content: '';
    background: url(${MenuSeparator}) center left no-repeat;
    background-size: cover;
    position: absolute;
    top: 0 ;
    left: 0 ;
    color: pink;
    height: 100%;
    width: 42px;
  }
  span {
    font-family: 'breuer_condensedbold', sans-serif;
    ${'' /* font-weight: 500; */}
    text-transform: uppercase;
    text-rendering: optimizeLegibility;
    letter-spacing: 1px;
    font-size: 1.3rem;
    margin-right: 70px;
    @media( max-width:1000px) {
      display:none;
    }
  }
  @media( min-width:768px) {
    min-height: 70px;
    min-width: 220px;
    max-width: 280px;
  }
`
const ContactMenuIcon = styled.button `
  position:absolute;
  top: 1rem;
  right: 1.2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  cursor:pointer;
  outline:blue;
  border:none;
  width: 42px;
  height: 32px;
  background: transparent;
  z-index: 200;
  @media( max-width:767px) {
    top: .65rem;
  }
  div {
    width: 34px;
    height: 2px;
    transform-origin: 1px;
    position:relative;
    background: #fff;
  }
`

const ContactMenuLinks = styled.nav `
  display:flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  position: absolute;
  z-index:300;
  background: rgba(255,255,255,.9);
  backdrop-filter: blur(5px);
  
  height: calc(100vh - 70px);
  top: 70px;
  
  @media( max-width:767px) {
    height: calc(100vh - 56px);
    top: 56px;
  }
  @media( min-width:768px) { 
    flex-direction: row;
    -webkit-flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    text-align: center;
  }
  right: 0;
  bottom: 0;

  transition: all 200ms ease-in-out;
  transform: ${({navbarOpen}) => navbarOpen ? "translateX(0%)" : "translateX(0%)"  };
  opacity: ${({navbarOpen}) => navbarOpen ? "300" : "0"  };
  z-index: ${({navbarOpen}) => navbarOpen ? "300" : "-1"  };
  div.copyright {
    position: absolute;
    bottom: 10px;
    left: 10px;
    font-size: 12px;
    font-weight:500;
  }
  div.links-container {
    width: 80%;
    max-width: 1200px;
    height: 420px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin: 0 auto;
    @media( max-width:767px) { 
      flex-direction: column;
      -webkit-flex-direction: column;
      align-items: center;
      width: 100%;
      max-width: 100%;
    }
  }
  @media only screen and (-webkit-min-device-pixel-ratio: 1.25) {
    height: calc(var(--vh, 1vh) * 112 - 0px);
  }
  @media only screen and (-webkit-min-device-pixel-ratio: 1.35) and (-webkit-max-device-pixel-ratio: 1.5)  {
    height: calc(var(--vh, 1vh) * 125 - 0px);
  }
`
const ContactMenuLinkBlock = styled.div `
  display:block;
  width: 100%;
  padding: 1rem 0;
  @media( min-width:768px) { 
    display:flex;
    flex-wrap: wrap;
    align-items: flex-start; 
    width: 50%;
  }
  a {
    width: 100%;
    text-align: center;
    margin-bottom: 2rem;
    @media( min-width:768px) { 
    text-align: left;
    }
  }
  a, h1 {
    text-decoration: none;
    color: #004a93; 
    text-transform: uppercase;
    font-family: 'breuer_condensedbold', sans-serif;
  }
  h1 {
    margin-bottom:0;
    font-weight: 500;
    margin-left: -3px;
    @media( min-width:1280px) { 
      font-size: 4.5vw;
    }
  }

`

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}


export default function Header ({ siteTitle }) {
  
  const [navbarOpen, setNavbarOpen] = useState(false)

  const queryRes = useStaticQuery(query)
  const strapiGlobal = queryRes.strapiGlobal

  const getFileNameFromUrl = (url) =>( (url || "").split("/").pop() )
  console.log(strapiGlobal);

  return (

    <HeaderBar>
      
        
        <HeaderLogo>
        
          <Link to="/">
            <img src={Logo} alt={siteTitle || strapiGlobal.defaultSeo.metaTitle} />
          </Link>

        </HeaderLogo>

        <ContactMenuStyles
          onClick={() => setNavbarOpen(!navbarOpen)}
        >
          <span>
          {navbarOpen ? 'Close' : 'Contact Us'}

          </span>
          
          <ContactMenuIcon
            
          >
            <div />
            <div />
            <div />
          </ContactMenuIcon>
        </ContactMenuStyles>

        <ContactMenuLinks navbarOpen={navbarOpen}>
          <div className={"links-container"}>
            <ContactMenuLinkBlock>
              <a href={`mailto:${strapiGlobal.NavEmail}?subject=InfinityMAX Info Request`} target="_blank" rel="noreferrer">
                <h1>Email Us</h1>
                {strapiGlobal.NavEmail}
              </a>
            </ContactMenuLinkBlock>
            
            <ContactMenuLinkBlock>
              <a href={strapiGlobal.NavPDF.url} download target="_blank" rel="noreferrer">
                <h1>Download PDF</h1>
                { getFileNameFromUrl(strapiGlobal.NavPDF.url) }
              </a>
            </ContactMenuLinkBlock>
            
            <ContactMenuLinkBlock>
              <a href={strapiGlobal.NavWebsite} target="_blank" rel="noreferrer">
                <h1>Visit</h1>
                {strapiGlobal.NavWebsite}
              </a>
            </ContactMenuLinkBlock>
            <div className="copyright">
                © {new Date().getFullYear()}, Stena Bulk LLC
            </div>
          </div>

        </ContactMenuLinks>

        
    </HeaderBar>

  )

}
const query = graphql`
query {
  strapiGlobal {
    NavEmail
    NavPDF {
      url
    }
    NavWebsite
    defaultSeo {
      metaTitle
    }
  }
}
`